import { useHeight } from '../hooks';

import { ReactPlayer } from './ReactPlayer';
import { VideoProps } from './types';

export const PlayerComponent = ({ src, description, editable }: VideoProps) => {
  const { maxHeight, editorHeight } = useHeight();

  const height = editable ? editorHeight : maxHeight;

  return (
    <ReactPlayer
      src={src}
      description={description}
      width="100%"
      height={height}
      controls
      preload="metadata"
      autoPlay={false}
    />
  );
};
